import React from "react";
import OwlCarousel from "react-owl-carousel2";
import SectionTitle from "../../components/Common/SectionTitle";
import SingleTestimonial from "../../components/Testimonial/SingleTestimonial";
import { useSelector } from "react-redux";

import quote from "../../assets/img/testimonial/quote.png";

function Testimonial() {
  const s3Url = "https://pms-project-s3.s3.ap-south-1.amazonaws.com/";
  const options = {
    items: 3,
    nav: false,
    dots: true,
    touchDrag: true,
    margin: 30,
    rewind: false,
    autoplay: false,
    stagePadding: 30,
    loop: true,
    center: false,
    responsive: {
      0: {
        stagePadding: 0,
        items: 1,
        dots: true,
      },
      768: {
        items: 2,
        stagePadding: 0,
        dots: true,
      },
      992: {
        items: 2,
        stagePadding: 0,
      },
      1200: {
        items: 3,
        stagePadding: 0,
      },
      1500: {
        items: 3,
        stagePadding: 0,
      },
    },
  };

  const testimonials = useSelector((state) => state.data.testimonial);

  return (
    <React.Fragment>
      <div className="rs-testimonial main-home gray-bg pt-20 pb-120 md-pt-20 md-pb-80">
        <div className="container " style={{ marginTop: "50px" }}>
          <SectionTitle
            sectionClass="sec-title2 text-center mb-46 pt-16"
            subtitleClass="sub-text"
            subtitle="  "
            titleClass="title testi-title"
            title="Reviews"
            effectClass="heading-line"
          />
          <OwlCarousel options={options}>
            {testimonials.map((testimonial, index) => (
              <SingleTestimonial
                key={index}
                itemClass="testi-item"
                quoteImage={quote}
                authorImage={s3Url + testimonial.profileImage}
                Title={testimonial.name}
                Description={testimonial.content}
              />
            ))}
          </OwlCarousel>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Testimonial;
